if(!customElements.get('menu-toggle')) {
  class MenuToggle extends HTMLElement {
    connectedCallback() {
      this.toggleClass = this.getAttribute('toggle-class') || 'is-menu-open';
      this.contentSelector = this.getAttribute('content') || '#content';
      this.menuSelector = this.getAttribute('menu') || '.menu--main';
      this.menu = this.menuSelector ? document.querySelector(this.menuSelector) : null;
      this.controls = this.getAttribute('controls') || this.menu?.id;
      this.closeOnClickOutside = this.hasAttribute('close-outside');

      this.$html = document.documentElement;
      this.toggleButton = this.querySelector('button, a');
      this.closeImage = this.querySelector('.icon--close');
      this.openImage = this.querySelector('.icon--open');

      this.toggleButton?.setAttribute('aria-controls', this.controls);
      this.toggleButton?.addEventListener('click', () => this.onClick());
      window.addEventListener('keyup', (e) => this.onWindowKeyUp(e));
      window.addEventListener('click', (e) => this.onWindowClick(e));
      document.querySelector(this.contentSelector)?.addEventListener('click', (e) => this.close());
    }

    close() {
      this.$html.classList.remove('is-menu-open');
      this.setFocus(this.contentSelector);
      this.toggleButton.setAttribute('aria-expanded', 'false');

      this.openImage?.removeAttribute('hidden');
      this.closeImage?.setAttribute('hidden', 'hidden');

      window.scroll(0, this.previousScrollPosition);
      this.isOpen = false;
    }

    open() {
      this.$html.classList.add('is-menu-open');
      this.setFocus(this.menuSelector);
      this.toggleButton.setAttribute('aria-expanded', 'true');
      this.closeImage?.removeAttribute('hidden');
      this.openImage?.setAttribute('hidden', 'hidden');

      this.previousScrollPosition = window.scrollY;

      setTimeout(() => window.scroll(0,0), 10);

      this.isOpen = true;
    }

    onWindowClick(e) {
      const isClickedOnCloseButton = e.target.closest('.close') || e.target.matches('.close');
      const clickedOutsideMenu = !e.target.closest(this.menuSelector) && !e.target.matches(this.menuSelector);
      const clickedOutsideButton = !this.toggleButton.contains(e.target) && e.target !== this.toggleButton;

      if (isClickedOnCloseButton) this.close();
      if (clickedOutsideMenu && clickedOutsideButton && this.closeOnClickOutside && this.isOpen) this.close();
    }

    onWindowKeyUp(e) {
      if (e.key.toLowerCase() === 'escape') {
        this.close();
      }
    }

    onClick() {
      if (this.$html.classList.contains(this.toggleClass)) {
        this.close();
      } else {
        this.open();
      }
    }


    setFocus(selector) {
      const item = document.querySelector(selector);

      setTimeout(() => {
        if (item) item.focus();
      }, 250);
    }
  }

  customElements.define('menu-toggle', MenuToggle);
}